<ps-footer>
  <ps-footer-links>
    <ng-container
      [ngTemplateOutlet]="isCombinedApplication ? combinedApplicationRef : brandApplicationRef"
    ></ng-container>
    <ps-divider></ps-divider>
  </ps-footer-links>
  <ps-footer-content id="footer-content">{{ 'FOOTER.FOOTER_CONTENT' | translate }}</ps-footer-content>
</ps-footer>

<ng-template #brandApplicationRef>
  <a class="ps-margin-bottom-small">&copy; {{ 'FOOTER.PAYSAFE_HOLDINGS_UK_LIMITED' | translate }}</a>
  <div *ngIf="showHelpSection" class="ps-margin-bottom-small help-section">
    <a>
      {{ 'FOOTER.CONNECT_WITH_US' | translate }}
    </a>
    <a href="{{ 'FOOTER.HELP_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.HELP' | translate }}
    </a>
  </div>
  <div>
    <app-social-media [brand]="brand"></app-social-media>
    <a href="{{ 'FOOTER.TERMS_AND_CONDITIONS_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.TERMS_AND_CONDITIONS' | translate }}
    </a>
    <a href="{{ 'FOOTER.PRIVACY_POLICY_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.PRIVACY_POLICY' | translate }}
    </a>
    <a href="{{ 'FOOTER.COOKIE_NOTICE_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.COOKIE_NOTICE' | translate }}
    </a>
    <a>
      {{ 'FOOTER.COOKIE_SETTINGS' | translate }}
    </a>
  </div>
</ng-template>

<ng-template #combinedApplicationRef>
  <a class="ps-margin-bottom-small">&copy; {{ 'FOOTER.PAYSAFE_HOLDINGS_UK_LIMITED' | translate }}</a>
  <div *ngIf="showHelpSection" class="ps-margin-bottom-small help-section">
    <a>
      {{ 'FOOTER.CONNECT_WITH_US' | translate }}
    </a>
    <a href="{{ 'FOOTER.HELP_SKRILL_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.HELP_SKRILL' | translate }}
    </a>
    <a href="{{ 'FOOTER.HELP_NETELLER_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.HELP_NETELLER' | translate }}
    </a>
  </div>
  <div>
    <app-social-media [brand]="brand"></app-social-media>
    <a href="{{ 'FOOTER.TERMS_AND_CONDITIONS_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.TERMS_AND_CONDITIONS' | translate }}
    </a>
    <a href="{{ 'FOOTER.PRIVACY_POLICY_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.PRIVACY_POLICY' | translate }}
    </a>
    <a href="{{ 'FOOTER.COOKIE_NOTICE_LINK' | translate }}" target="_blank">
      {{ 'FOOTER.COOKIE_NOTICE' | translate }}
    </a>
    <a>
      {{ 'FOOTER.COOKIE_SETTINGS' | translate }}
    </a>
  </div>
</ng-template>
